import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/** Backpack `OrderFill` レスポンススキーマ */
export const fillSchema = z.object({
  /** クライアント側オーダー ID */
  clientId: z.string().nullish(),
  /** 手数料 (feeSymbol で表される資産単位) */
  fee: decimalSchema,
  /** 手数料がチャージされる資産シンボル */
  feeSymbol: z.string(),
  /** メーカー側の約定か */
  isMaker: z.boolean(),
  /** 約定したオーダー ID */
  orderId: z.string(),
  /** 約定価格 */
  price: decimalSchema,
  /** 約定数量 */
  quantity: decimalSchema,
  /** 売買方向 */
  side: z.enum(['Bid', 'Ask']),
  /** 約定が発生した market シンボル (例: `SOL_USDC`, `SOL_USDC_PERP`) */
  symbol: z.string(),
  /** システムオーダー種別 (清算/ADL/担保変換等) */
  systemOrderType: z.string().nullish(),
  /** 約定時刻 (naive ISO date-time) */
  timestamp: z.string(),
  /** Trade ID */
  tradeId: z.number().nullish(),
})

export const fillsResponseSchema = z.array(fillSchema)

export type Fill = z.infer<typeof fillSchema>
